var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"appearance-from-top"}},[(_vm.activatePanel && _vm.isShowMobileFilterButton && _vm.currentScrollTop >= _vm.startPosition)?_c('div',{staticClass:"comparator-mobile-filter-panel"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }